import { render, staticRenderFns } from "./CardAlertSoundEffect.vue?vue&type=template&id=9b407e50&scoped=true&"
import script from "./CardAlertSoundEffect.vue?vue&type=script&lang=js&"
export * from "./CardAlertSoundEffect.vue?vue&type=script&lang=js&"
import style0 from "./CardAlertSoundEffect.vue?vue&type=style&index=0&id=9b407e50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b407e50",
  null
  
)

export default component.exports